module.exports = __webpack_public_path__ + "pc/img/img_award2022_01.57c65ce8.webp";